import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { User } from 'src/app/models/user.model';

@Component({
    selector: 'que-mini-contact-display',
    imports: [CommonModule],
    templateUrl: './mini-contact-display.component.html',
    styleUrls: ['./mini-contact-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MiniContactDisplayComponent implements OnInit {
  @Input()
  user?: User;
  @Input()
  numGroups?: number;
  @Input()
  isTooltip: boolean = false;
  @Input()
  isData: boolean = false;
  @Input()
  isSelect: boolean = false;
  @Input() color: string = "#B7C7FC";
  @Input()
  mainAnswer?: string;

  ngOnInit(): void {
    if (this.isData) {
      this.isTooltip = true;
    }
  }
}
